export default {
    AUTHENTICATION: {
        DEV: [
            11,  // Mastercard crédito
            10,  // Visa crédito
            25,  // Mastercard
            20,  // Elo crédito
            36,  // Elo débito
            24,  // Visa débito
            18  // Amex crédito
        ],
        SDB: [
            2,  // Mastercard crédito
            1,  // Visa crédito
            29, // Mastercard
            28,  // Visa débito
            9,  // Elo crédito
            37, // Elo débito
            7  // Amex crédito
        ],
        PRD: [
            1,  //Visa crédito 
            2,  // Mastercard crédito
            13, // Visa débito
            14, // Mastercard
            9,  // Elo crédito
            19, // Elo débito
            7  // Amex crédito
        ]
    },

    DATAONLY: {
        DEV: [
            11,  // Mastercard crédito
            25,  // Mastercard
            10,  // Visa crédito
        ],
        SDB: [
            2,  // Mastercard crédito
            29, // Mastercard
            1,  // Visa crédito
        ],
        PRD: [
            2,  // Mastercard crédito
            14, // Mastercard
            1,  //Visa crédito
        ]
    }
};
